module.exports = __webpack_public_path__ + "img/ORTHOMOLECULAR.f6fc8d95.png";